/* Stick Snak PDP — gallery thumbnail switching. */
(function () {
  function init() {
    document.querySelectorAll('[data-ss-pdp]').forEach((root) => {
      if (root.dataset.ssInit) return;
      root.dataset.ssInit = '1';
      const stageImgs = Array.from(root.querySelectorAll('.ss-pdpv3__stage-img'));
      const thumbs = Array.from(root.querySelectorAll('[data-ss-thumb]'));
      thumbs.forEach((btn) => {
        btn.addEventListener('click', () => {
          const i = Number(btn.dataset.ssThumb);
          stageImgs.forEach((img, j) => { img.style.display = j === i ? 'block' : 'none'; });
          thumbs.forEach((t) => t.classList.toggle('is-active', t === btn));
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
